<script>
import {environment} from '@app/store/envStore.svelte.js';
import { canUseLocalCcEmbed } from '@app/lib/ccEmbed.js';
import {
    modalState, hideModal, showModal
} from '@app/store/modalStore.svelte.js';
import {
    fade
} from 'svelte/transition';
import * as m from "@app/paraglide/messages.js";
let fileType = $state(localStorage.getItem("cc-default-import-settings") || "mediaImport");

function saveDefaultSettings(opt){
    //Save the current settings as the default settings in local storage using the key cc-default-export-settings
    localStorage.setItem("cc-default-import-settings", opt);
}

function selectImportType(opt) {
    fileType = opt;
    saveDefaultSettings(opt);
    showModal(opt);
}
</script>

<div transition:fade={{duration: 100}} 
    class="modal {modalState.selected === 'fileImport' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="importTitle"
    aria-modal="true"
    tabindex="-1" 
    id="ImportModal">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="importTitle">{m.file_import_title()}</h4>
                <button type="button" 
                    class="btn-close" 
                    id="importClose"
                    aria-label={m.file_import_close_label()} 
                    onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <div class="row row-cols-1 row-cols-md-3 g-3" aria-label={m.file_import_form_label()}>
                    <div class="col">
                        <button type="button"
                            class="card h-100 action-card btn p-0 w-100 import-option {fileType === 'mediaImport' ? 'active' : ''}"
                            onclick={() => selectImportType('mediaImport')}
                            aria-label={m.file_import_media_label()}>
                                <div class="card-body text-center py-4">
                                    <i class="bi bi-camera-reels fs-2 mb-2" aria-hidden="true"></i>
                                    <h5 class="card-title mb-0">{m.file_import_media_label()}</h5>
                                </div>
                        </button>
                    </div>
                    <div class="col">
                        <button type="button"
                            class="card h-100 action-card btn p-0 w-100 import-option {fileType === 'subtitleImport' ? 'active' : ''}"
                            onclick={() => selectImportType('subtitleImport')}
                            aria-label={m.file_import_subtitle_label()}>
                                <div class="card-body text-center py-4">
                                    <i class="bi bi-file-text fs-2 mb-2" aria-hidden="true"></i>
                                    <h5 class="card-title mb-0">{m.file_import_subtitle_label()}</h5>
                                </div>
                        </button>
                    </div>
                    {#if canUseLocalCcEmbed()}
                        <div class="col">
                            <button type="button"
                                class="card h-100 action-card btn p-0 w-100 import-option {fileType === 'subtitleExtract' ? 'active' : ''}"
                                onclick={() => selectImportType('subtitleExtract')}
                                aria-label={m.file_import_extract_label()}>
                                    <div class="card-body text-center py-4">
                                        <i class="bi bi-badge-cc fs-2 mb-2" aria-hidden="true"></i>
                                        <h5 class="card-title mb-0">{m.file_import_extract_label()}</h5>
                                    </div>
                            </button>
                        </div>
                    {/if}
                    <div class="col">
                        <button type="button"
                            class="card h-100 action-card btn p-0 w-100 import-option {fileType === 'translationImport' ? 'active' : ''}"
                            onclick={() => selectImportType('translationImport')}
                            aria-label={m.file_import_translation_label()}>
                                <div class="card-body text-center py-4">
                                    <i class="bi bi-translate fs-2 mb-2" aria-hidden="true"></i>
                                    <h5 class="card-title mb-0">{m.file_import_translation_label()}</h5>
                                </div>
                        </button>
                    </div>
                    <div class="col">
                        <button type="button"
                            class="card h-100 action-card btn p-0 w-100 import-option {fileType === 'plainTextImport' ? 'active' : ''}"
                            onclick={() => selectImportType('plainTextImport')}
                            aria-label={m.file_import_plaintext_label()}>
                                <div class="card-body text-center py-4">
                                    <i class="bi bi-file-earmark-text fs-2 mb-2" aria-hidden="true"></i>
                                    <h5 class="card-title mb-0">{m.file_import_plaintext_label()}</h5>
                                </div>
                        </button>
                    </div>
                    <div class="col">
                        <button type="button"
                            class="card h-100 action-card btn p-0 w-100 import-option {fileType === 'projectImport' ? 'active' : ''}"
                            onclick={() => selectImportType('projectImport')}
                            aria-label={m.file_import_project_label()}>
                                <div class="card-body text-center py-4">
                                    <i class="bi bi-folder fs-2 mb-2" aria-hidden="true"></i>
                                    <h5 class="card-title mb-0">{m.file_import_project_label()}</h5>
                                </div>
                        </button>
                    </div>
                    {#if environment.online}
                        <div class="col">
                            <button type="button"
                                class="card h-100 action-card btn p-0 w-100 import-option {fileType === 'teamProjectImport' ? 'active' : ''}"
                                onclick={() => selectImportType('teamProjectImport')}
                                aria-label={m.file_import_team_project_label()}>
                                    <div class="card-body text-center py-4">
                                        <i class="bi bi-people fs-2 mb-2" aria-hidden="true"></i>
                                        <h5 class="card-title mb-0">{m.file_import_team_project_label()}</h5>
                                    </div>
                            </button>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .action-card {
        transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        border: none;
        background: linear-gradient(135deg, var(--bs-body-bg) 0%, var(--bs-light-bg-subtle) 100%);
        border-radius: 1rem;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
        display: block;
        text-align: center;
        font-weight: normal;
        position: relative;
        overflow: hidden;
    }

    .action-card::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(135deg, var(--bs-primary) 0%, color-mix(in srgb, var(--bs-primary) 70%, black) 100%);
        opacity: 0;
        transition: opacity 0.4s ease;
        border-radius: 1rem;
    }

    .action-card:hover,
    .action-card.active {
        transform: translateY(-4px) scale(1.02);
        box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
    }

    .action-card:hover::before,
    .action-card.active::before {
        opacity: 1;
    }

    .action-card .card-body {
        position: relative;
        z-index: 1;
    }

    .action-card i,
    .action-card .card-title {
        transition: all 0.4s ease;
    }

    .action-card:hover i,
    .action-card:hover .card-title,
    .action-card.active i,
    .action-card.active .card-title {
        color: white;
        transform: scale(1.1);
    }

    .import-option:focus {
        outline: 2px solid var(--bs-primary);
        outline-offset: 2px;
    }
</style>
